<template>
  <div>
    <Header />
    <Project1Details />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer";
import Header from "../components/Header"
import Project1Details from "../components/Project1Details";
import Contact from "../components/Contact";

export default {
  name: "Project1",
  components: {
    Header,
    Footer,
    Project1Details,
    Contact,
  }
};
</script>
